<template>
    <div>
        <div class="container-fluid">
            <div v-if="currentView == 'list'">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="alert alert-success alert-dismissible" role="alert" v-if="isSave">
                            <button type="button" class="close" aria-label="Close"  @click="isSave = false"><span aria-hidden="true">&times;</span></button>
                            <strong>Success!</strong> Broadcast "{{sent_name}}" sent
                        </div>
                        <div class="alert alert-success alert-dismissible" role="alert" v-if="isCopy">
                            <button type="button" class="close" aria-label="Close"  @click="isCopy = false"><span aria-hidden="true">&times;</span></button>
                            <strong>Success!</strong> Broadcast "{{copy_name}}" copy
                        </div>
                        <div class="alert alert-danger alert-dismissible" role="alert" v-if="isFail">
                            <button type="button" class="close" aria-label="Close"  @click="isFail = false"><span aria-hidden="true">&times;</span></button>
                            <strong>Oop!</strong> Broadcast "{{name}}" save draft fail
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">
                        <h3 class="title">Broadcast</h3>
                    </div>
                    <div class="col-sm-4 text-right">
                        <a href="javascript:void(0);" class="btn btn-primary" @click="selected_edit_broadcast = undefined;currentView = 'edit'"><i class="fas fa-plus"></i> Add new broadcast</a>
                    </div>
                </div>

                <h4>Draft</h4>
                <div style="border: 1px solid #eee; border-radius: 10px;overflow: auto">
                    <table class="table" >
                        <thead>
                            <tr style="border-bottom: 3px solid #eee;">
                                <td class="text-center">Date</td>
                                <td>Name</td>
                                <td class="text-center">Status</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="loading">
                                <tr>
                                    <td colspan="4" class="text-center" style="padding: 10px 0px">
                                        <scale-loader :color="$store.state.theme.brand_color" height="35px" width="7px"></scale-loader>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <template v-if="draft_broadcasts && draft_broadcasts.length > 0">
                                <tr v-for="(broadcast, index) in draft_broadcasts" :key="'draft_broadcast_'+index">
                                    <td class="text-center" style="padding-left: 15px;padding-right: 15px;white-space: nowrap;">{{broadcast.createdtime | DateFormat('DD/MM/YYYY hh:mm A')}}</td>
                                    <td style="width: 350px;max-width: 350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{broadcast.name}}</td>
                                    <td class="text-center" style="padding-left: 15px;padding-right: 15px;"><span class="label label-default">Draft</span></td>
                                    <td class="text-center" style="white-space: nowrap;">
                                        <a href="javascript:void(0);" class="btn btn-gray btn-sm transparent" @click="deleteBroadcast(broadcast.id, broadcast.name)"><i class="fas fa-trash"></i> Delete</a>
                                        <a href="javascript:void(0);" class="btn btn-gray btn-sm transparent" @click="copyBroadcast(index, 'draft')"><i class="fas fa-copy"></i> Copy</a>
                                        <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" @click="editBroadcast(index)"><i class="fas fa-pencil-alt"></i> Edit</a>
                                    </td>
                                </tr>
                                </template>
                                <tr v-else>
                                    <td colspan="4">
                                        <p class="text-center" style="margin-top: 25px">No draft broadcast</p>

                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>

                <br>

                <h4>Sent</h4>
                <div style="border: 1px solid #eee; border-radius: 10px;overflow: auto">
                    <table class="table" >
                        <thead>
                            <tr style="border-bottom: 3px solid #eee;">
                                <td class="text-center">Date</td>
                                <td>Name</td>
                                <td class="text-center">Status</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="loading">
                                <tr>
                                    <td colspan="4" class="text-center" style="padding: 10px 0px">
                                        <scale-loader :color="$store.state.theme.brand_color" height="35px" width="7px"></scale-loader>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <template v-if="sent_broadcasts && sent_broadcasts.length > 0">
                                    <tr v-for="(broadcast, index) in sent_broadcasts" :key="'sent_broadcast_'+index">
                                        <td class="text-center" style="padding-left: 15px;padding-right: 15px;white-space: nowrap;"><template v-if="broadcast.senttime">{{broadcast.senttime | DateFormat('DD/MM/YYYY hh:mm A')}}</template><template v-else>-</template></td>
                                        <td style="width: 350px;max-width: 350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{broadcast.name}}</td>
                                        <td class="text-center" style="padding-left: 15px;padding-right: 15px;"><span class="label label-success">Sent</span></td>
                                        <td class="text-center" style="white-space: nowrap;">
                                            <a href="javascript:void(0);" class="btn btn-gray btn-sm transparent"><i class="fas fa-copy" @click="copyBroadcast(index, 'sent')"></i> Copy</a>
                                            <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" @click="viewBroadcast(index)"><i class="fas fa-eye"></i> View</a>
                                        </td>
                                    </tr>
                                </template>
                                <tr v-else>
                                    <td colspan="4">
                                        <p class="text-center" style="margin-top: 25px">No sent broadcast</p>

                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>

            <broadcast-manage v-else-if="currentView == 'edit'" @onClose="onClose" :value="selected_edit_broadcast" @onSave="onSave"></broadcast-manage>
            <broadcast-view v-else-if="currentView == 'view'" @onClose="onClose" :value="selected_view_broadcast"></broadcast-view>
            
        </div>
    </div>
</template>

<script>
    import BroadcastManage from './BroadcastManage'
    import BroadcastView from './BroadcastView'
    import api from '@/api'
    import { mapGetters, mapMutations } from 'vuex'
    import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

    export default {
        data: function(){
            return {
                copy_name: '',
                sent_name: '',
                isSave: false,
                isCopy: false,
                currentView: 'list',
                isFail: false,
                draft_broadcasts: [],
                sent_broadcasts: [],
                selected_edit_broadcast: undefined,
                selected_view_broadcast: undefined,
                loading: true
            }
        },
        components: {
            BroadcastManage,
            BroadcastView,
            ScaleLoader
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot',
            })
        },
        mounted: function(){
            var vm = this
            vm.loading = true
            vm.getBroadcast(function(){
                vm.loading = false
            })
        },
        methods: {
            onClose: function(payload){
                var vm = this
                vm.currentView = 'list'
                vm.loading = true
                if (payload) {
                    vm.sent_name = payload
                    vm.isSave = true
                }
                vm.getBroadcast(function(){
                    vm.loading = false
                })
            },
            getBroadcast: function(callback){
                var vm = this
                api.getBroadcast(vm.selectedBot.pageid, function(error, response) {
                    if (error) {
                        console.error(error);
                        callback()
                        return;
                    }
                    if (response.data.length > 0) {
                        vm.draft_broadcasts = []
                        vm.sent_broadcasts = []
                        $.each(response.data,function(index, broadcast){
                            if (broadcast.status == 'draft') {
                                vm.draft_broadcasts.push(broadcast)
                            } else {
                                vm.sent_broadcasts.push(broadcast)
                            }
                        })
                    }
                    callback()
                })
            },
            editBroadcast: function(index){
                this.selected_edit_broadcast = this.draft_broadcasts[index]
                this.currentView = 'edit'
            },
            viewBroadcast: function(index){
                this.selected_view_broadcast = this.sent_broadcasts[index]
                this.currentView = 'view'
            },
            deleteBroadcast: function(broadcastid,broadcastname){
                if (confirm("Do you want to detele \""+broadcastname+"\"?")) {
                    var vm = this
                    // vm.loading = true
                    api.deleteBroadcast({pageid: vm.selectedBot.pageid, broadcastid: broadcastid}, function(error, response) {
                        if (error) {
                            console.error(error);
                            // vm.loading = true
                            return;
                        }
                        
                        $.each(vm.draft_broadcasts,function(index, broadcast){
                            if (broadcast.id == broadcastid) {
                                vm.draft_broadcasts.splice(index,1)
                                return false
                            }
                        })
                    })
                }
            },
            onSave: function(payload){
                var vm = this
                vm.saveBroadcast(payload.data,function(status,id){
                    payload.onSave(status,id)
                })
            },
            copyBroadcast: function(index, type){
                var vm = this
                var data = undefined
                if (type == 'draft') {
                    data = Object.assign({}, vm.draft_broadcasts[index])
                } else if(type == 'sent') {
                    data = Object.assign({}, vm.sent_broadcasts[index])
                }

                if (confirm("Do you want to copy \""+data.name+"\"? ")) {
                    
                    data.id = null
                    data.name += " copy"
                    data.sendflag = false,
                    data.page_access_token = vm.selectedBot.page_access_token,
                    vm.copy_name = data.name
                    vm.saveBroadcast(data,function(status,id){
                        if (status) {
                            data.id = id
                            vm.draft_broadcasts.unshift(data)
                            vm.isCopy = true
                            vm.$nextTick(function(){
                                $("html, body").animate({ scrollTop: 0 });
                            })
                        }
                    })
                }
            },
            saveBroadcast: function(data,callback){
                api.updateBroadcast(data, function(error, response) {
                    if (error) {
                        console.error(error);
                        callback(false,null)
                        return;
                    }
                    var id = null
                    if (response.broadcastid) {
                        id = response.broadcastid
                    }
                    callback(true,id)
                    
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/broadcast/broadcast.vue